module.exports = __webpack_public_path__ + "static/img/3.b2f1981.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/showcase/xi/my/4/3.png
// module id = 5UhC
// module chunks = 1